import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "prependContent", "layout"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVEntry, GridFromJson } from '@uswitch/ev-core/react';
import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { contentId } from '@uswitch/ev-utils/contentful';
import { createElement as _createElement } from "theme-ui";
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var Grid = function Grid(_ref) {
  var content = _ref.content,
      prependContent = _ref.prependContent,
      layout = _ref.layout,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useEntity = useEntity(layout),
      layoutEntity = _useEntity.layout;

  var childrenArray = [prependContent].concat(content.map(function (entity) {
    return _createElement(EVEntry, _objectSpread(_objectSpread({}, entity), {}, {
      key: contentId(entity)
    }));
  })).filter(function (i) {
    return i;
  });
  return _jsx(GridFromJson, _objectSpread(_objectSpread({}, props), {}, {
    json: layoutEntity,
    childrenArray: childrenArray
  }));
};

export default Grid;
//# sourceMappingURL=grid-from-json.connected.js.map